import React from 'react'
import '../../css/table.css'
import { orderBy } from 'lodash'
import ReactTable from 'react-table'
import Card from 'components/Card/Card.jsx'
import { db } from '../../services/firebase'
import Modal from 'components/Modal/Modal.jsx'
import DiscountForm from '../../forms/DiscountForm.jsx'
import SweetAlert from 'react-bootstrap-sweetalert'
import Button from 'elements/CustomButton/CustomButton.jsx'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import SweetSpinner from 'components/SweetSpinner/SweetSpinner.jsx'
import { Grid, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'


export default class Discounts extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            discounts: [],
            loading: false,
            discountModal: false,
            alert: null,
            targetDiscount: null,
        }

        this.user = props.user
        this.resetForm = props.resetForm
        this.submitForm = props.submitForm
        this.notify = props.notify
    }

    componentDidMount() {
        this._fetchDiscounts()
    }


    render() {
        const { discounts, alert, loading } = this.state
        return (
            <div className='main-content'>
                {alert}
                {this.discountModal()}
                <Card content={
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <Button
                                    bsStyle='default'
                                    wd
                                    className='pull-right'
                                    style={{ marginBottom: 10 }}
                                    onClick={() => {
                                        this.props.resetForm('DiscountForm')
                                        this.setState({ discountModal: true, targetDiscount: null })
                                    }}
                                >
                                    Adicionar Desconto
                            </Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <ReactTable
                                    columns={[
                                        { Header: 'Nome', accessor: 'name' },
                                        {
                                            Header: 'Ações', accessor: '',
                                            Cell: ({ value }) => (this._renderTableActions(value))
                                        }
                                    ]}
                                    data={orderBy(discounts, ['name', 'asc'])}
                                    onFetchData={this._fetchDiscounts}
                                    loading={loading}
                                    defaultPageSize={10}
                                    className='-striped -highlight'
                                    previousText='Anterior'
                                    nextText='Próximo'
                                    loadingText='Carregando'
                                    noDataText='Nenhum desconto encontrado'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='Registros'
                                />
                            </Col>
                        </Row>
                    </Grid>
                } />
            </div>
        )
    }

    discountModal = () => {
        const { discountModal, targetDiscount } = this.state
        return (
            <Modal
                className='modal__big'
                title={targetDiscount ? 'Atualizar desconto' : 'Adicionar desconto'}
                isOpen={discountModal}
                content={
                    <DiscountForm
                        initialValues={targetDiscount}
                        onSubmit={values => targetDiscount ? this._updateDiscount(values) : this._addDiscount(values)}
                        handleCancel={() => this.setState({ discountModal: false })}
                    />
                }
            />
        )
    }

    _renderTableActions = value => (
        <div style={{ textAlign: 'center' }}>
            <OverlayTrigger
                placement='top'
                overlay={(<Tooltip id={`edit_${value.id}`}>Editar</Tooltip>)}
            >
                <a
                    className='btn btn-simple btn-default btn-icon'
                    onClick={() => this.setState({ targetDiscount: value, discountModal: true })}
                >
                    <FontAwesomeIcon className='text-dark' icon='edit' />
                </a>
            </OverlayTrigger>

            <OverlayTrigger
                placement='top'
                overlay={(<Tooltip id={`edit_${value.id}`}>Configurar</Tooltip>)}
            >
                <a
                    className='btn btn-simple btn-default btn-icon'
                    onClick={() => this.props.history.push(`/discount/${value.id}`)}
                >
                    <FontAwesomeIcon className='text-dark' icon='clipboard' />
                </a>
            </OverlayTrigger>

            <OverlayTrigger
                placement='top'
                overlay={(<Tooltip id={`remove_${value.id}`}>Remover</Tooltip>)}
            >
                <a
                    className='btn btn-simple btn-default btn-icon'
                    onClick={() => this.removeDiscountAlert(value.id)}
                >
                    <FontAwesomeIcon className='text-dark' icon='trash' />
                </a>
            </OverlayTrigger>
        </div>
    )

    /**************** 
        Fetch data from Firestore
    *****************/

    _fetchDiscounts = () => {
        this.setState({ loading: true })
        db.collection('discounts').onSnapshot(snapshot => {
            if (!snapshot.empty) {
                const discounts = []
                snapshot.forEach(d => discounts.push({ ...d.data(), id: d.id }))
                this.setState({ discounts, loading: false })
            } else {
                this.setState({ loading: false })
            }
        })
    }

    /**************** 
        Add data to Firestore
    *****************/

    _addDiscount = data => {
        this.setState({ discountModal: false })
        this.waitAlert('Adicionando desconto', true)

        const { name } = data
        db.collection('discounts').add({ name })
            .then(() => {
                this.hideAlert()
                this.props.notify('Desconto adicionado.', 'success')
            })
            .catch(e => {
                this.hideAlert()
                this.props.notify('Erro ao adicionar desconto.', 'error')
            })
    }


    /**************** 
       Update Firestore data
   *****************/

    _updateDiscount = data => {
        this.setState({ discountModal: false })
        this.waitAlert('Atualizando desconto', true)

        const { targetDiscount } = this.state
        const { name } = data

        db.collection('discounts').doc(targetDiscount.id).update({ name })
            .then(() => {
                this.hideAlert()
                this.setState({ targetDiscount: null })
                this.props.notify('Desconto atualizado.', 'success')
            })
            .catch(e => {
                this.hideAlert()
                this.setState({ targetDiscount: null })
                this.props.notify('Erro ao atualizar desconto.', 'error')
            })
    }

    _removeDiscount = discountID => {
        this.waitAlert('Removendo desconto', false)
        db.collection('users').where('discount', '==', discountID).get()
            .then(snapshot => {
                if (!snapshot.empty) {
                    this.hideAlert()
                    this.props.notify('Não é possível remover um desconto vinculado a um ou mais parceiros.', 'warning')
                }

                if (snapshot.empty) {
                    db.collection('discounts').doc(discountID).collection('conditions').get()
                        .then(conditions => {
                            if (!conditions.empty) {
                                const ConditionStack = []
                                conditions.forEach(c => ConditionStack.push(db.collection('discounts').doc(discountID).collection('conditions').doc(c.id).delete()))

                                Promise.all(ConditionStack)
                                    .then(() => {
                                        db.collection('discounts').doc(discountID).delete()
                                            .then(() => { this.hideAlert() })
                                            .catch(e => {
                                                this.hideAlert()
                                                this.props.notify('Erro ao remover desconto.', 'error')
                                            })
                                    })
                                    .catch(e => {
                                        this.hideAlert()
                                        this.props.notify('Erro ao remover desconto.', 'error')
                                    })
                            }

                            if (!conditions.empty) {
                                db.collection('discounts').doc(discountID).delete()
                                    .then(() => {
                                        this.hideAlert()
                                        this.props.notify('Desconto removido.', 'success')
                                    })
                                    .catch(e => {
                                        this.hideAlert()
                                        this.props.notify('Erro ao remover desconto.', 'error')
                                    })
                            }
                        })
                        .catch(e => {
                            this.hideAlert()
                            this.props.notify('Erro ao remover desconto.', 'error')
                        })
                }
            })
            .catch(e => {
                this.hideAlert()
                this.props.notify('Erro ao remover desconto.', 'error')
            })
    }

    //SweetAlerts
    hideAlert = () => this.setState({ alert: null })

    waitAlert = (title, showSpinner) => {
        this.setState({
            alert: (
                <SweetAlert
                    style={{ display: 'block' }}
                    title={title}
                    onConfirm={() => null}
                    showConfirm={false}
                >
                    {showSpinner ? (<SweetSpinner />) : null}
                </SweetAlert>
            )
        })
    }

    removeDiscountAlert = discountID => {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{ display: "block" }}
                    title="Tem certeza?"
                    onConfirm={() => this._removeDiscount(discountID)}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="default"
                    cancelBtnBsStyle="warning"
                    confirmBtnText="Continuar"
                    cancelBtnText="Cancelar"
                    showCancel
                />
            )
        });
    }
}


// WEBPACK FOOTER //
// ./src/views/Discounts/Discounts.jsx